var _rect, _g, _g2, _g3, _circle, _circle2, _circle3, _circle4, _circle5, _ellipse, _circle6, _circle7, _circle8, _ellipse2, _circle9, _ellipse3, _circle0, _ellipse4, _circle1, _circle10, _circle11, _ellipse5, _circle12, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _ellipse0, _ellipse1, _ellipse10, _ellipse11, _ellipse12, _ellipse13, _ellipse14, _ellipse15, _ellipse16, _ellipse17, _ellipse18, _ellipse19, _ellipse20, _ellipse21, _ellipse22, _g4, _path, _g5, _g6, _path2, _path3, _circle13, _circle14, _circle15, _circle16, _circle17, _ellipse23, _circle18, _ellipse24, _circle19, _circle20, _ellipse25, _ellipse26, _ellipse27, _ellipse28, _ellipse29, _ellipse30, _ellipse31, _ellipse32, _ellipse33, _ellipse34, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnterprisePlatformModernization(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1280,
    height: 832,
    viewBox: "0 0 1280 832",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1280,
    height: 832,
    fill: "#221D30"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_950_4425)",
    filter: "url(#filter0_d_950_4425)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 590.31,
    height: 338,
    transform: "translate(47 203.175) rotate(-9.57338)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.5859,
    y: 408.24,
    width: 590.31,
    height: 158.185,
    transform: "rotate(-9.57338 81.5859 408.24)",
    fill: "#F1F3F6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.988,
    cy: 299.4,
    r: 8.30123,
    transform: "rotate(-9.57338 102.988 299.4)",
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 97.16,
    cy: 264.839,
    r: 8.30123,
    transform: "rotate(-9.57338 97.16 264.839)",
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 110.738,
    cy: 345.331,
    r: 8.30123,
    transform: "rotate(-9.57338 110.738 345.331)",
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 116.566,
    cy: 379.892,
    r: 8.30123,
    transform: "rotate(-9.57338 116.566 379.892)",
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.438,
    y: 417.199,
    width: 18.9084,
    height: 17.0636,
    transform: "rotate(-9.57338 114.438 417.199)",
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.336,
    y: 469.95,
    width: 18.9084,
    height: 17.0636,
    transform: "rotate(-9.57338 123.336 469.95)",
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.234,
    y: 221.139,
    width: 73.3276,
    height: 11.0683,
    transform: "rotate(-9.57338 112.234 221.139)",
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.148,
    y: 250.243,
    width: 73.3276,
    height: 23.9813,
    transform: "rotate(-9.57338 117.148 250.243)",
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.648,
    y: 270.692,
    width: 73.3276,
    height: 23.9813,
    transform: "rotate(-9.57338 206.648 270.692)",
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.32,
    y: 316.168,
    width: 73.3276,
    height: 23.9813,
    transform: "rotate(-9.57338 214.32 316.168)",
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 297.992,
    y: 302.056,
    width: 73.3276,
    height: 23.9813,
    transform: "rotate(-9.57338 297.992 302.056)",
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 387.492,
    y: 322.505,
    width: 73.3276,
    height: 23.9813,
    transform: "rotate(-9.57338 387.492 322.505)",
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.453,
    y: 412.137,
    width: 73.3276,
    height: 17.0636,
    transform: "rotate(-9.57338 144.453 412.137)",
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148.898,
    y: 438.513,
    width: 73.3276,
    height: 17.0636,
    transform: "rotate(-9.57338 148.898 438.513)",
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153.344,
    y: 464.888,
    width: 73.3276,
    height: 17.0636,
    transform: "rotate(-9.57338 153.344 464.888)",
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 157.797,
    y: 491.264,
    width: 73.3276,
    height: 17.0636,
    transform: "rotate(-9.57338 157.797 491.264)",
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228.125,
    y: 398.024,
    width: 73.3276,
    height: 17.0636,
    transform: "rotate(-9.57338 228.125 398.024)",
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.023,
    y: 450.776,
    width: 73.3276,
    height: 17.0636,
    transform: "rotate(-9.57338 237.023 450.776)",
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241.469,
    y: 477.152,
    width: 73.3276,
    height: 17.0636,
    transform: "rotate(-9.57338 241.469 477.152)",
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 311.797,
    y: 383.912,
    width: 73.3276,
    height: 17.0636,
    transform: "rotate(-9.57338 311.797 383.912)",
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.242,
    y: 410.288,
    width: 73.3276,
    height: 17.0636,
    transform: "rotate(-9.57338 316.242 410.288)",
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.695,
    y: 436.664,
    width: 73.3276,
    height: 17.0636,
    transform: "rotate(-9.57338 320.695 436.664)",
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 395.469,
    y: 369.799,
    width: 73.3276,
    height: 17.0636,
    transform: "rotate(-9.57338 395.469 369.799)",
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 404.367,
    y: 422.551,
    width: 73.3276,
    height: 17.0636,
    transform: "rotate(-9.57338 404.367 422.551)",
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 408.82,
    y: 448.927,
    width: 73.3276,
    height: 17.0636,
    transform: "rotate(-9.57338 408.82 448.927)",
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 479.156,
    y: 355.685,
    width: 73.3276,
    height: 17.0636,
    transform: "rotate(-9.57338 479.156 355.685)",
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 483.602,
    y: 382.061,
    width: 73.3276,
    height: 17.0636,
    transform: "rotate(-9.57338 483.602 382.061)",
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 488.055,
    y: 408.437,
    width: 73.3276,
    height: 17.0636,
    transform: "rotate(-9.57338 488.055 408.437)",
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 492.5,
    y: 434.813,
    width: 73.3276,
    height: 17.0636,
    transform: "rotate(-9.57338 492.5 434.813)",
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 562.828,
    y: 341.574,
    width: 73.3276,
    height: 17.0636,
    transform: "rotate(-9.57338 562.828 341.574)",
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 567.273,
    y: 367.95,
    width: 73.3276,
    height: 17.0636,
    transform: "rotate(-9.57338 567.273 367.95)",
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 571.719,
    y: 394.326,
    width: 73.3276,
    height: 17.0636,
    transform: "rotate(-9.57338 571.719 394.326)",
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 465.352,
    y: 273.829,
    width: 73.3276,
    height: 23.9813,
    transform: "rotate(-9.57338 465.352 273.829)",
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 535.523,
    y: 179.68,
    width: 73.3276,
    height: 23.9813,
    transform: "rotate(-9.57338 535.523 179.68)",
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195.914,
    y: 207.026,
    width: 73.3276,
    height: 11.0683,
    transform: "rotate(-9.57338 195.914 207.026)",
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279.586,
    y: 192.914,
    width: 73.3276,
    height: 11.0683,
    transform: "rotate(-9.57338 279.586 192.914)",
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 363.258,
    y: 178.802,
    width: 73.3276,
    height: 11.0683,
    transform: "rotate(-9.57338 363.258 178.802)",
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 446.945,
    y: 164.687,
    width: 73.3276,
    height: 11.0683,
    transform: "rotate(-9.57338 446.945 164.687)",
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 530.609,
    y: 150.576,
    width: 73.3276,
    height: 11.0683,
    transform: "rotate(-9.57338 530.609 150.576)",
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.062 403.101L632.759 315.281",
    stroke: "#BBC2D1",
    strokeWidth: 0.46118
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.7891 324.428L619.486 236.608",
    stroke: "#BBC2D1",
    strokeWidth: 0.46118
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.297 250.364L237.455 242.579L241.213 264.862",
    stroke: "#F1F3F6",
    strokeWidth: 9.22359
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.195 288.511L248.877 310.339",
    stroke: "#F1F3F6",
    strokeWidth: 9.22359
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.617 315.797L299.986 313.88",
    stroke: "#F1F3F6",
    strokeWidth: 9.22359
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.297 301.683L415.954 294.32L419.788 317.058",
    stroke: "#F1F3F6",
    strokeWidth: 9.22359
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.957 323.042L509.252 315.065L505.263 291.417",
    stroke: "#F1F3F6",
    strokeWidth: 9.22359
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.645 273.459L587.85 265.329L576.345 197.115",
    stroke: "#F1F3F6",
    strokeWidth: 9.22359
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_950_4425)",
    filter: "url(#filter1_d_950_4425)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M548.247 30.7817C548.576 25.3794 553.223 21.2674 558.625 21.5972L1165.09 58.6252C1170.49 58.9551 1174.6 63.6019 1174.27 69.0041L1150.62 456.358C1150.29 461.761 1145.65 465.873 1140.24 465.543L533.781 428.515C528.379 428.185 524.267 423.538 524.596 418.136L548.247 30.7817Z",
    fill: "#221D30"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 564.859,
    y: 40.1412,
    width: 592.893,
    height: 373.186,
    transform: "rotate(3.49389 564.859 40.1412)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 555.992,
    y: 67.0907,
    width: 607.313,
    height: 134.258,
    transform: "rotate(3.49389 555.992 67.0907)",
    fill: "#0054AA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 716.375,
    y: 131.374,
    width: 278.807,
    height: 25.4797,
    rx: 4.89994,
    transform: "rotate(3.49389 716.375 131.374)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M978.409 153.762C981.243 154.079 983.359 156.568 983.184 159.446L983.16 159.723C983.049 160.71 982.673 161.609 982.111 162.356L985.425 165.726L984.027 167.1L980.668 163.683C979.747 164.261 978.644 164.569 977.476 164.497L977.199 164.474C974.457 164.166 972.386 161.826 972.414 159.066L972.424 158.789C972.606 155.818 975.162 153.557 978.133 153.738L978.409 153.762ZM978.013 155.694C976.123 155.579 974.496 157.018 974.381 158.909C974.265 160.799 975.705 162.425 977.595 162.541C979.486 162.656 981.112 161.217 981.227 159.327C981.343 157.436 979.904 155.81 978.013 155.694Z",
    fill: "#0054AA"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M688.199 239.126L1115.17 265.195L1108.45 375.239L681.481 349.17L688.199 239.126Z",
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M680.047 372.646L777.864 378.618L774.91 426.951L677.094 420.979L680.047 372.646Z",
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M789.596 379.334L887.413 385.307L884.459 433.64L786.642 427.668L789.596 379.334Z",
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M899.644 386.053L997.46 392.026L994.507 440.359L896.69 434.387L899.644 386.053Z",
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1009.19 392.742L1107.01 398.714L1104.06 447.048L1006.24 441.075L1009.19 392.742Z",
    fill: "#BBC2D1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M576.688 232.317L618.748 234.885L618.211 243.689L576.15 241.121L576.688 232.317Z",
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.044 324.754L613.104 327.322L612.567 336.126L570.506 333.558L571.044 324.754Z",
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.613 249.924L645.062 254.165L644.763 259.055L575.314 254.815L575.613 249.924Z",
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.794 279.71L643.243 283.95L642.944 288.841L573.495 284.6L573.794 279.71Z",
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.177 371.706L637.626 375.946L637.327 380.837L567.878 376.597L568.177 371.706Z",
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.969 342.361L639.418 346.601L639.119 351.492L569.67 347.252L569.969 342.361Z",
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.015 259.706L635.172 263.379L634.873 268.27L574.717 264.597L575.015 259.706Z",
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.197 289.491L633.353 293.164L633.055 298.055L572.898 294.382L573.197 289.491Z",
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.58 381.488L627.736 385.161L627.438 390.052L567.281 386.379L567.58 381.488Z",
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.372 352.143L629.528 355.816L629.229 360.707L569.073 357.034L569.372 352.143Z",
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.418 269.488L648.269 273.997L647.97 278.887L574.119 274.379L574.418 269.488Z",
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.597 299.322L642.046 303.562L641.747 308.453L572.298 304.213L572.597 299.322Z",
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.774 361.924L642.625 366.433L642.326 371.324L568.476 366.815L568.774 361.924Z",
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M704.817 256.34L746.878 258.908L746.34 267.712L704.279 265.144L704.817 256.34Z",
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1051.88 79.6948L1119.37 83.8156L1118.83 92.619L1051.34 88.4982L1051.88 79.6948Z",
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1126.71 84.2635L1141.38 85.1593L1140.84 93.9622L1126.17 93.0664L1126.71 84.2635Z",
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.997 50.6396L618.057 53.2077L617.52 62.011L575.459 59.443L575.997 50.6396Z",
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M706.227 402.226L748.287 404.794L747.75 413.597L705.689 411.029L706.227 402.226Z",
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M815.775 408.914L857.836 411.482L857.298 420.286L815.238 417.718L815.775 408.914Z",
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M925.823 415.633L967.884 418.201L967.346 427.005L925.285 424.437L925.823 415.633Z",
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1035.38 422.322L1077.44 424.89L1076.9 433.694L1034.84 431.126L1035.38 422.322Z",
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M703.861 271.991L1086.81 295.372L1086.52 300.263L703.563 276.882L703.861 271.991Z",
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M702.667 291.554L1082.2 314.727L1081.9 319.618L702.368 296.445L702.667 291.554Z",
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M703.264 281.773L1077.41 304.617L1077.11 309.507L702.966 286.663L703.264 281.773Z",
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700.875 320.899L730.709 322.721L730.41 327.612L700.577 325.79L700.875 320.899Z",
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M740.499 323.319L770.333 325.14L770.034 330.031L740.201 328.209L740.499 323.319Z",
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M780.109 325.737L809.942 327.558L809.644 332.449L779.81 330.628L780.109 325.737Z",
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M819.726 328.156L849.559 329.977L849.261 334.868L819.427 333.047L819.726 328.156Z",
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M702.07 301.336L1013.62 320.358L1013.32 325.248L701.771 306.227L702.07 301.336Z",
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-56-inside-1_950_4425",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M548.227 30.9814C548.563 25.4688 553.305 21.2728 558.817 21.6094L1164.69 58.6014C1170.2 58.938 1174.4 63.6797 1174.06 69.1923L1150.45 456.019C1150.11 461.531 1145.37 465.727 1139.85 465.391L533.981 428.399C528.468 428.062 524.272 423.32 524.609 417.808L548.227 30.9814Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M548.227 30.9814C548.563 25.4688 553.305 21.2728 558.817 21.6094L1164.69 58.6014C1170.2 58.938 1174.4 63.6797 1174.06 69.1923L1150.45 456.019C1150.11 461.531 1145.37 465.727 1139.85 465.391L533.981 428.399C528.468 428.062 524.272 423.32 524.609 417.808L548.227 30.9814Z",
    stroke: "#221D30",
    strokeWidth: 40,
    mask: "url(#path-56-inside-1_950_4425)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_950_4425)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 20,
    transform: "matrix(-1 0 0 1 714 554)",
    fill: "#00BC56"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 13.5,
    r: 13.5,
    transform: "matrix(-1 0 0 1 610 704)",
    fill: "#BBC2D1"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 13,
    transform: "matrix(-1 0 0 1 679 751)",
    fill: "#BBC2D1"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 13,
    transform: "matrix(-1 0 0 1 764 735)",
    fill: "#BBC2D1"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 13,
    transform: "matrix(-1 0 0 1 444 703)",
    fill: "#BBC2D1"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 13,
    transform: "matrix(-1 0 0 1 371 660)",
    fill: "#BBC2D1"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.5,
    cy: 13,
    rx: 13.5,
    ry: 13,
    transform: "matrix(-1 0 0 1 388 744)",
    fill: "#BBC2D1"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 13,
    transform: "matrix(-1 0 0 1 306 715)",
    fill: "#BBC2D1"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 13,
    transform: "matrix(-1 0 0 1 241 684)",
    fill: "#BBC2D1"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 13,
    transform: "matrix(-1 0 0 1 102 723)",
    fill: "#BBC2D1"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.5,
    cy: 13,
    rx: 13.5,
    ry: 13,
    transform: "matrix(-1 0 0 1 717.086 672)",
    fill: "#BBC2D1"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 13,
    transform: "matrix(-1 0 0 1 499 654)",
    fill: "#BBC2D1"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.5,
    cy: 13,
    rx: 13.5,
    ry: 13,
    transform: "matrix(-1 0 0 1 531 739)",
    fill: "#BBC2D1"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 13.5,
    r: 13.5,
    transform: "matrix(-1 0 0 1 902 585)",
    fill: "#BBC2D1"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13,
    cy: 13.5,
    rx: 13,
    ry: 13.5,
    transform: "matrix(-1 0 0 1 806 629)",
    fill: "#BBC2D1"
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 13,
    transform: "matrix(-1 0 0 1 836 728)",
    fill: "#BBC2D1"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 13,
    transform: "matrix(-1 0 0 1 888 670)",
    fill: "#BBC2D1"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 13,
    transform: "matrix(-1 0 0 1 932 738)",
    fill: "#BBC2D1"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13,
    cy: 13.5,
    rx: 13,
    ry: 13.5,
    transform: "matrix(-1 0 0 1 167 650)",
    fill: "#BBC2D1"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 13,
    transform: "matrix(-1 0 0 1 186 744)",
    fill: "#BBC2D1"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.5,
    cy: 16.5,
    rx: 24.5,
    ry: 16.5,
    transform: "matrix(-1 0 0 1 621 736)",
    fill: "#BBC2D1"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 25,
    cy: 16.5,
    rx: 25,
    ry: 16.5,
    transform: "matrix(-1 0 0 1 691 782)",
    fill: "#BBC2D1"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 25,
    cy: 16.5,
    rx: 25,
    ry: 16.5,
    transform: "matrix(-1 0 0 1 776 766)",
    fill: "#BBC2D1"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.5,
    cy: 16.5,
    rx: 24.5,
    ry: 16.5,
    transform: "matrix(-1 0 0 1 456 734)",
    fill: "#BBC2D1"
  })), _ellipse0 || (_ellipse0 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 25,
    cy: 16.5,
    rx: 25,
    ry: 16.5,
    transform: "matrix(-1 0 0 1 383 691)",
    fill: "#BBC2D1"
  })), _ellipse1 || (_ellipse1 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.5,
    cy: 16.5,
    rx: 24.5,
    ry: 16.5,
    transform: "matrix(-1 0 0 1 399 775)",
    fill: "#BBC2D1"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 25,
    cy: 16.5,
    rx: 25,
    ry: 16.5,
    transform: "matrix(-1 0 0 1 318 746)",
    fill: "#BBC2D1"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 25,
    cy: 16.5,
    rx: 25,
    ry: 16.5,
    transform: "matrix(-1 0 0 1 253 715)",
    fill: "#BBC2D1"
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 25,
    cy: 16.5,
    rx: 25,
    ry: 16.5,
    transform: "matrix(-1 0 0 1 114 754)",
    fill: "#BBC2D1"
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.5,
    cy: 16.5,
    rx: 24.5,
    ry: 16.5,
    transform: "matrix(-1 0 0 1 728.086 703)",
    fill: "#BBC2D1"
  })), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 25,
    cy: 16.5,
    rx: 25,
    ry: 16.5,
    transform: "matrix(-1 0 0 1 511 685)",
    fill: "#BBC2D1"
  })), _ellipse15 || (_ellipse15 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.5,
    cy: 16.5,
    rx: 24.5,
    ry: 16.5,
    transform: "matrix(-1 0 0 1 542 770)",
    fill: "#BBC2D1"
  })), _ellipse16 || (_ellipse16 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.5,
    cy: 16.5,
    rx: 24.5,
    ry: 16.5,
    transform: "matrix(-1 0 0 1 913 617)",
    fill: "#BBC2D1"
  })), _ellipse17 || (_ellipse17 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 25,
    cy: 16.5,
    rx: 25,
    ry: 16.5,
    transform: "matrix(-1 0 0 1 848 759)",
    fill: "#BBC2D1"
  })), _ellipse18 || (_ellipse18 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.5,
    cy: 16.5,
    rx: 24.5,
    ry: 16.5,
    transform: "matrix(-1 0 0 1 900 701)",
    fill: "#BBC2D1"
  })), _ellipse19 || (_ellipse19 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 25,
    cy: 16.5,
    rx: 25,
    ry: 16.5,
    transform: "matrix(-1 0 0 1 944 769)",
    fill: "#BBC2D1"
  })), _ellipse20 || (_ellipse20 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 25,
    cy: 16.5,
    rx: 25,
    ry: 16.5,
    transform: "matrix(-1 0 0 1 179 682)",
    fill: "#BBC2D1"
  })), _ellipse21 || (_ellipse21 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 25,
    cy: 16.5,
    rx: 25,
    ry: 16.5,
    transform: "matrix(-1 0 0 1 198 775)",
    fill: "#BBC2D1"
  })), _ellipse22 || (_ellipse22 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 25,
    cy: 16.5,
    rx: 25,
    ry: 16.5,
    transform: "matrix(-1 0 0 1 818 661)",
    fill: "#BBC2D1"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter3_d_950_4425)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 295,
    height: 148,
    rx: 20,
    transform: "matrix(-0.998266 -0.0588626 -0.0588626 0.998266 350.094 290.811)",
    fill: "#00BC56"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 295,
    height: 148,
    rx: 20,
    transform: "matrix(-0.998052 0.0623861 0.0623861 0.998052 1029.09 352.942)",
    fill: "#00BC56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104 679L84.0814 406.75H123.919L104 679Z",
    fill: "#00BC56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M792 612L772.081 481.5H811.919L792 612Z",
    fill: "#00BC56"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 295,
    height: 148,
    rx: 20,
    transform: "matrix(-0.999226 -0.039336 -0.039336 0.999226 1248.8 182.859)",
    fill: "#00BC56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1190 520L1170.08 312.25H1209.92L1190 520Z",
    fill: "#00BC56"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M664 570L656.367 593.493L631.664 593.493L651.649 608.013L644.015 631.507L664 616.987L683.985 631.507L676.351 608.013L696.336 593.493L671.633 593.493L664 570Z",
    fill: "white"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_950_4425)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 20,
    transform: "matrix(-1 0 0 1 554 454)",
    fill: "#00BC56"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_950_4425)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 20,
    transform: "matrix(-1 0 0 1 409 520)",
    fill: "#00BC56"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M504 470L496.367 493.493L471.664 493.493L491.649 508.013L484.015 531.507L504 516.987L523.985 531.507L516.351 508.013L536.336 493.493L511.633 493.493L504 470Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M359 536L351.367 559.493L326.664 559.493L346.649 574.013L339.015 597.507L359 582.987L378.985 597.507L371.351 574.013L391.336 559.493L366.633 559.493L359 536Z",
    fill: "white"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 1014.5,
    cy: 754.5,
    r: 13.5,
    fill: "#BBC2D1"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 1098.5,
    cy: 744.5,
    r: 13.5,
    fill: "#BBC2D1"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 1188.5,
    cy: 740.5,
    r: 13.5,
    fill: "#BBC2D1"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 1224,
    cy: 665,
    r: 13,
    fill: "#BBC2D1"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 1139,
    cy: 649,
    r: 13,
    fill: "#BBC2D1"
  })), _ellipse23 || (_ellipse23 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1121.5,
    cy: 530,
    rx: 13.5,
    ry: 13,
    fill: "#BBC2D1"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 1188,
    cy: 564,
    r: 13,
    fill: "#BBC2D1"
  })), _ellipse24 || (_ellipse24 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1008,
    cy: 595.5,
    rx: 13,
    ry: 13.5,
    fill: "#BBC2D1"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 1054,
    cy: 664,
    r: 13,
    fill: "#BBC2D1"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 958,
    cy: 674,
    r: 13,
    fill: "#BBC2D1"
  })), _ellipse25 || (_ellipse25 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1014.5,
    cy: 789.5,
    rx: 24.5,
    ry: 16.5,
    fill: "#BBC2D1"
  })), _ellipse26 || (_ellipse26 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1098.5,
    cy: 779.5,
    rx: 24.5,
    ry: 16.5,
    fill: "#BBC2D1"
  })), _ellipse27 || (_ellipse27 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1188.5,
    cy: 775.5,
    rx: 24.5,
    ry: 16.5,
    fill: "#BBC2D1"
  })), _ellipse28 || (_ellipse28 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1224,
    cy: 699.5,
    rx: 25,
    ry: 16.5,
    fill: "#BBC2D1"
  })), _ellipse29 || (_ellipse29 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1139,
    cy: 683.5,
    rx: 25,
    ry: 16.5,
    fill: "#BBC2D1"
  })), _ellipse30 || (_ellipse30 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1121.5,
    cy: 564.5,
    rx: 24.5,
    ry: 16.5,
    fill: "#BBC2D1"
  })), _ellipse31 || (_ellipse31 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1188,
    cy: 598.5,
    rx: 25,
    ry: 16.5,
    fill: "#BBC2D1"
  })), _ellipse32 || (_ellipse32 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1054,
    cy: 698.5,
    rx: 25,
    ry: 16.5,
    fill: "#BBC2D1"
  })), _ellipse33 || (_ellipse33 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 958,
    cy: 708.5,
    rx: 25,
    ry: 16.5,
    fill: "#BBC2D1"
  })), _ellipse34 || (_ellipse34 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1008,
    cy: 630.5,
    rx: 25,
    ry: 16.5,
    fill: "#BBC2D1"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_950_4425",
    x: 39.0657,
    y: 100.239,
    width: 654.173,
    height: 447.336,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.17371
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.96714
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_950_4425"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_950_4425",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_950_4425",
    x: 516.498,
    y: 16.4986,
    width: 665.872,
    height: 460.145,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.00092
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.75115
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_950_4425"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_950_4425",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_950_4425",
    x: 604,
    y: 548,
    width: 120,
    height: 120,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_950_4425"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_950_4425",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_950_4425",
    x: 38.0391,
    y: 166.026,
    width: 1219.98,
    height: 526.974,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_950_4425"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_950_4425",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_950_4425",
    x: 444,
    y: 448,
    width: 120,
    height: 120,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_950_4425"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_950_4425",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_950_4425",
    x: 299,
    y: 514,
    width: 120,
    height: 120,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_950_4425"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_950_4425",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_950_4425"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 590.31,
    height: 338,
    fill: "white",
    transform: "translate(47 203.175) rotate(-9.57338)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_950_4425"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 627.193,
    height: 407.675,
    fill: "white",
    transform: "translate(548.844 21) rotate(3.49389)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnterprisePlatformModernization);
export default __webpack_public_path__ + "static/media/EnterprisePlatformModernization.36c15b797a4f9fc32e7527746326750b.svg";
export { ForwardRef as ReactComponent };